import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { sizeTablet, printHidden, buttonReset, standardPaddingSm } from '~/styles';

type IconGroupWrapperProps = {
  kind: 'classes' | 'articles';
};

export const IconWrapper = styled.div`
  ${buttonReset};
  margin: 0 0 5px 0;
  margin-bottom: ${standardPaddingSm};
  padding: 1px 7px 2px 7px;
  transition: opacity 250ms ease-in-out;

  &:hover,
  &:focus {
    cursor: pointer;
    opacity: 0.5;
  }

  path {
    fill: rgb(111, 111, 111);
    height: 19;
  }
`;

export const Button = styled.button`
  border: none;
  background: inherit;
  padding: 0;
`;

export const IconGroupWrapper = styled.div<IconGroupWrapperProps>`
  position: absolute;
  left: calc((100vw - 1140px) / 2);
  top: 150px;
  display: flex;
  flex-direction: column;
  position: static;
  flex-direction: row;
  justify-content: center;

  ${({ kind }: IconGroupWrapperProps) =>
    kind === 'classes'
      ? 'padding-top: 50px;'
      : kind === 'articles'
      ? css`
          padding-top: 20px;
          ${sizeTablet(css`
            padding-top: 0px;
          `)};
        `
      : null};

  ${sizeTablet(css`
    top: 100px;
    left: calc((100vw - 170px) / 2);
  `)};
  ${printHidden};
`;
